<div class="form-modal" style="width: 700px">
    <h1 mat-dialog-title>{{this.processNumber}}</h1>
    <div mat-dialog-content>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <table class="table table-bordered display">
                        <thead>
                            <tr>
                                <th>
                                    <strong>{{ 'ID' | translate }}</strong>
                                </th>
                                <th>
                                    <strong>{{ 'DOCUMENT' | translate }}</strong>
                                </th>
                                <th>
                                    <strong>{{ 'VERSION' | translate }}</strong>
                                </th>
                                <th>
                                    <strong>{{ 'STATUS' | translate }}</strong>
                                </th>
                                <th>
                                    <strong>{{ 'N_DOCUMENT' | translate }}</strong>
                                </th>
                                <th>
                                    <strong>{{ 'PDF' | translate }}</strong>
                                </th>
                            </tr>
                            <tr *ngFor="let document of documents; let i = index" [ngSwitch]="1">
                                <th class="vertical-middle">{{document.ID}}</th>
                                <th class="vertical-middle">{{document.DocumentType}}</th>
                                <th class="vertical-middle">{{document.DocumentVersion}}</th>
                                <th class="vertical-middle">{{document.DocumentState}}</th>
                                <th class="vertical-middle">{{document.DocumentNumber}}</th>
                                <th><a class="btn table-export-PDF" title="{{ 'DOWNLOAD_DOCUMENT' | translate }}"
                                        data-attrid=' + data.ID + ' (click)="getDocumentPDF(document.ID)"><i class="far fa-file-pdf red"></i></a></th>
                            </tr>
                        </thead>
                        <tbody></tbody>
                    </table>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 spacer-bottom-xs"></div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <div class="full-width text-right">
            <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
                (click)="dialogRef.close(null)">
                <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
            </button>
            <button type="button" class="btn btn-default" title="{{ 'DOWNLOAD_ALL_DOCUMENTS' | translate}}"
                (click)="getAllPDFsDocuments()">
                <i class="far fa-file-pdf red"></i>
            </button>
        </div>
    </div>
</div>